/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Badge_ChineseInputs */

const en_directory_badge_chinese = /** @type {(inputs: Directory_Badge_ChineseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文支持`)
};

const zh_directory_badge_chinese = /** @type {(inputs: Directory_Badge_ChineseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文支持`)
};

/**
* | output |
* | --- |
* | "中文支持" |
*
* @param {Directory_Badge_ChineseInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_badge_chinese = /** @type {((inputs?: Directory_Badge_ChineseInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Badge_ChineseInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_badge_chinese(inputs)
	return zh_directory_badge_chinese(inputs)
});
export { directory_badge_chinese as "directory.badge.chinese" }